export class ResendPasswords {
  constructor(data) {
    /** @type {number[]} */
    this.userIds = data.userIds;
  }
}
